"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../atoms/Text");
const classnames_1 = __importDefault(require("classnames"));
// Modal with transitions, can't be used until react and testing-library versions are updated.
// The headlessui elements are not accessible with the outdated version of testing-library in icm.
function Modal({ testId, title, description, isOpen, children, wide = false, }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('relative z-50', { hidden: !isOpen }), "data-testid": testId },
        react_1.default.createElement("div", { className: "fixed inset-0 opacity-40 bg-gray-800" }),
        react_1.default.createElement("div", { className: "fixed inset-0 z-10 overflow-y-auto" },
            react_1.default.createElement("div", { className: "flex min-h-full justify-center text-center items-center" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('relative transform rounded-lg bg-defaultBg border border-borderColor text-left shadow-default transition-all', wide ? 'w-[514px]' : 'w-[424px]') },
                    react_1.default.createElement("div", { className: "p-8" },
                        title && react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.PAGE_HEADING }, title),
                        description && (react_1.default.createElement("div", { className: "mt-4" },
                            react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_M }, description)))),
                    children)))));
}
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map